function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "9",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 4H9a1 1 0 000 2h6a1 1 0 000-2zM16 9a1 1 0 00-1-1H9a1 1 0 000 2h6a1 1 0 001-1zM8 13a1.003 1.003 0 001 1h.44a6.793 6.793 0 011.08-2H9a1.003 1.003 0 00-1 1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "13",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "17",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.707 22.293l-2.677-2.677a5.506 5.506 0 10-1.415 1.414l2.678 2.677a1 1 0 001.414-1.414zM13 16.5a3.5 3.5 0 113.5 3.5 3.504 3.504 0 01-3.5-3.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.88 20H2V2h16v7.15a6.954 6.954 0 012 .73V2a2.006 2.006 0 00-2-2H2a2.006 2.006 0 00-2 2v18a2.006 2.006 0 002 2h9.42a6.865 6.865 0 01-1.54-2z"
})));